module.exports = __webpack_public_path__ + "img/23_BF1_forget the boardwalk.ce440c2c.jpg";